/**
 * Email validation
 * @param {string} email - Email to validate
 * @returns {boolean} - True if email is valid
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Password validation
 * @param {string} password - Password to validate
 * @returns {boolean} - True if password is valid
 */
export const isValidPassword = (password) => {
  // Minimum 8 characters, at least one letter and one number; allow special characters
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

/**
 * Password strength checker
 * @param {string} password - Password to check
 * @returns {number} - Strength score (0-4)
 */
export const passwordStrength = (password) => {
  let score = 0;
  
  // Length check
  if (password.length >= 8) score++;
  
  // Contains lowercase
  if (/[a-z]/.test(password)) score++;
  
  // Contains uppercase
  if (/[A-Z]/.test(password)) score++;
  
  // Contains number
  if (/\d/.test(password)) score++;
  
  // Contains special character
  if (/[^A-Za-z0-9]/.test(password)) score++;
  
  return score;
};

/**
 * Name validation
 * @param {string} name - Name to validate
 * @returns {boolean} - True if name is valid
 */
export const isValidName = (name) => {
  return name && name.trim().length >= 2;
};

/**
 * Phone validation
 * @param {string} phone - Phone to validate
 * @returns {boolean} - True if phone is valid
 */
export const isValidPhone = (phone) => {
  const phoneRegex = /^\+?[0-9]{10,15}$/;
  return !phone || phoneRegex.test(phone);
};
